function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "Component_4_1",
  "data-name": "Component 4 \\u2013 1",
  transform: "translate(0.691 0.723)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_113",
  "data-name": "Line 113",
  y1: 16.247,
  x2: 17,
  fill: "none",
  stroke: "#fff",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_114",
  "data-name": "Line 114",
  x2: 17,
  y2: 16.247,
  fill: "none",
  stroke: "#fff",
  strokeWidth: 2
}));

function SvgMenuClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.382,
    height: 17.693,
    viewBox: "0 0 18.382 17.693"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOC4zODIiIGhlaWdodD0iMTcuNjkzIiB2aWV3Qm94PSIwIDAgMTguMzgyIDE3LjY5MyI+CiAgPGcgaWQ9IkNvbXBvbmVudF80XzEiIGRhdGEtbmFtZT0iQ29tcG9uZW50IDQg4oCTIDEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNjkxIDAuNzIzKSI+CiAgICA8bGluZSBpZD0iTGluZV8xMTMiIGRhdGEtbmFtZT0iTGluZSAxMTMiIHkxPSIxNi4yNDciIHgyPSIxNyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiLz4KICAgIDxsaW5lIGlkPSJMaW5lXzExNCIgZGF0YS1uYW1lPSJMaW5lIDExNCIgeDI9IjE3IiB5Mj0iMTYuMjQ3IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMiIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgMenuClose as ReactComponent };